export default {
  setAutocomplete(state, data) {
    state.autocomplete = data;
  },

  setTransactions(state, data) {
    state.transactions = data;
  },

  setSubdistributors(state, data) {
    state.subdistributors = data;
  },

  setChains(state, data) {
    state.chains = data;
  },

  setStores(state, data) {
    state.stores = data;
  },

  setGrants(state, data) {
    state.grants = data;
  },

  setLoadingStatus(state, data) {
    state.loading = data;
  },

  clearAllState(state) {
    state.transactions = [];
    state.subdistributors = [];
    state.chains = [];
    state.stores = [];
    state.grants = [];
    state.installs = [];
    state.params = {
      distributor_id: null,
      subdistributor_id: null,
      chain_id: null,
      store_id: null,
    };
  },
};
